import { render, staticRenderFns } from "./iconSauna.vue?vue&type=template&id=441f79d6"
import script from "./iconSauna.vue?vue&type=script&lang=js"
export * from "./iconSauna.vue?vue&type=script&lang=js"
import style0 from "./iconSauna.vue?vue&type=style&index=0&id=441f79d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports